import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const CustomButton = withStyles({
  root: {
    padding: '6px 10px',
    width: 115,
    minHeight: 26,
    borderRadius: 3,
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 14,
    '&:active': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none'
    }
  }
})(Button)

export const LongCustomButton = withStyles({
  root: {
    width: 130
  }
})(CustomButton)

export const ExtraLongCustomButton = withStyles({
  root: {
    width: 175
  }
})(CustomButton)

export const CancelCustomButton = withStyles({
  root: {
    backgroundColor: '#666666',
    color: 'white',
    '&:hover': {
      backgroundColor: '#515151'
    }
  }
})(CustomButton)

export const OkDialogButton = withStyles({
  root: {
    // backgroundColor: 'transparent',
    // color: '#2075d7',
    marginLeft: 'auto',
    '&:hover': {
      // backgroundColor: 'transparent',
      // color: 'rgba(0, 0, 0, 0.87)'
    }
  }
})(CustomButton)

export default CustomButton
